export const ITALIAN_REGIONS = [
    { value: 'abr', label: 'Abruzzo' },
    { value: 'bas', label: 'Basilicata' },
    { value: 'cal', label: 'Calabria' },
    { value: 'cam', label: 'Campania' },
    { value: 'emr', label: 'Emilia-Romagna' },
    { value: 'fvg', label: 'Friuli-Venezia Giulia' },
    { value: 'laz', label: 'Lazio' },
    { value: 'lig', label: 'Liguria' },
    { value: 'lom', label: 'Lombardia' },
    { value: 'mar', label: 'Marche' },
    { value: 'mol', label: 'Molise' },
    { value: 'pie', label: 'Piemonte' },
    { value: 'pug', label: 'Puglia' },
    { value: 'sar', label: 'Sardegna' },
    { value: 'sic', label: 'Sicilia' },
    { value: 'tos', label: 'Toscana' },
    { value: 'taa', label: 'Trentino-Alto Adige' },
    { value: 'umb', label: 'Umbria' },
    { value: 'vda', label: "Valle d'Aosta" },
    { value: 'ven', label: 'Veneto' },
];
